import type { AdapterCodec, AdapterQuality, RProgram } from '../..';
import { KalturaStreamerType } from '../../phoenix/enums';
import { fetchChannelNextProgram, fetchProgram, isLiveProgram } from '../program';

import { fetchProgramPlaybackContextQuery as fetchProgramPlaybackContext } from './queries';
import type { PlaybackContext } from './types';

export type FetchNextProgramPlaybackDataArgs = {
  channelId: number;
  endDate: number;
  playbackContext: {
    adapterCodec: AdapterCodec;
    adapterDrm: boolean;
    adapterQuality: AdapterQuality;
    streamerType: KalturaStreamerType;
  };
};

export type ProgramPlaybackData = {
  program: RProgram;
  playbackContext: PlaybackContext;
};

export async function fetchNextProgramPlaybackData({
  channelId,
  endDate,
  playbackContext: { adapterCodec, adapterDrm, adapterQuality, streamerType },
}: FetchNextProgramPlaybackDataArgs): Promise<ProgramPlaybackData | undefined> {
  const nextProgram = await fetchChannelNextProgram({ channelId, endDate });

  if (!nextProgram) {
    return undefined;
  }

  if (nextProgram.hasMosaic) {
    return undefined;
  }

  const assetId = String(nextProgram.id);
  const contextType = isLiveProgram(nextProgram) ? 'START_OVER' : 'CATCHUP';

  const [program, playbackContext] = await Promise.all([
    fetchProgram({ id: assetId }),
    fetchProgramPlaybackContext({
      adapterCodec,
      adapterDrm: adapterDrm ? 'true' : 'false',
      adapterQuality,
      assetId,
      contextType,
      streamerType,
    }),
  ]);

  return {
    program,
    playbackContext,
  };
}
